export default class WorldCup2018 {
  constructor() {
    this.state = {
      flag1: {
        country: null,
        color1: null,
        color2: null,
        color3: null,
        color4: null,
      },
      flag2: {
        country: null,
        color1: null,
        color2: null,
        color3: null,
        color4: null,
      },
    };

    this.menu = {
      black: {
        ingredient1: {
          name: 'Zanahoria',
          image: 'black_carrot.png',
        },
        ingredient2: {
          name: 'Mazorca',
          image: 'black_corn.png',
        },
        ingredient3: {
          name: 'Berenjena',
          image: 'black_eggplant.png',
        },
        ingredient4: {
          name: 'Higo',
          image: 'black_fig.png',
        },
        ingredient5: {
          name: 'Ciruela',
          image: 'black_plum.png',
        },
        ingredient6: {
          name: 'Rábano',
          image: 'black_radish.png',
        },
      },
      blue: {
        ingredient1: {
          name: 'espárrago',
          image: 'blue_asparagus.png',
        },
        ingredient2: {
          name: 'coliflor',
          image: 'blue_cauliflower.png',
        },
        ingredient3: {
          name: 'mazorca',
          image: 'blue_corn.png',
        },
        ingredient4: {
          name: 'berenjena',
          image: 'blue_eggplant.png',
        },
        ingredient5: {
          name: 'cebolla',
          image: 'blue_onion.png',
        },
        ingredient6: {
          name: 'pimiento',
          image: 'blue_pepper.png',
        },
      },
      green: {
        ingredient1: {
          name: 'alcachofa',
          image: 'green_artichoke.png',
        },
        ingredient2: {
          name: 'espárrago',
          image: 'green_asparagus.png',
        },
        ingredient3: {
          name: 'aguacate',
          image: 'green_avocado.png',
        },
        ingredient4: {
          name: 'brócoli',
          image: 'green_broccolli.png',
        },
        ingredient5: {
          name: 'pepino',
          image: 'green_cucumber.png',
        },
        ingredient6: {
          name: 'pimiento',
          image: 'green_pepper.png',
        },
      },
      red: {
        ingredient1: {
          name: 'manzana',
          image: 'red_apple.png',
        },
        ingredient2: {
          name: 'remolacha',
          image: 'red_beet.png',
        },
        ingredient3: {
          name: 'Ají',
          image: 'red_chili.png',
        },
        ingredient4: {
          name: 'toronja',
          image: 'red_grapefruit.png',
        },
        ingredient5: {
          name: 'pimiento',
          image: 'red_pepper.png',
        },
        ingredient6: {
          name: 'tomate',
          image: 'red_tomato.png',
        },
      },
      white: {
        ingredient1: {
          name: 'coliflor',
          image: 'white_cauliflower.png',
        },
        ingredient2: {
          name: 'endivia',
          image: 'white_endives.png',
        },
        ingredient3: {
          name: 'Jícama',
          image: 'white_jicama.png',
        },
        ingredient4: {
          name: 'Champiñón',
          image: 'white_mushroom.png',
        },
        ingredient5: {
          name: 'cebolla',
          image: 'white_onion.png',
        },
        ingredient6: {
          name: 'patata',
          image: 'white_potato.png',
        },
      },
      yellow: {
        ingredient1: {
          name: 'mazorca',
          image: 'yellow_corn.png',
        },
        ingredient2: {
          name: 'limón',
          image: 'yellow_lemon.png',
        },
        ingredient3: {
          name: 'mango',
          image: 'yellow_mango.png',
        },
        ingredient4: {
          name: 'pimiento',
          image: 'yellow_pepper.png',
        },
        ingredient5: {
          name: 'piña',
          image: 'yellow_pineapple.png',
        },
        ingredient6: {
          name: 'calabacín',
          image: 'yellow_squash.png',
        },
      },
    };

    this.init();
  }

  init() {
    this.handleScroll();
    this.handleFlagSelector();
    this.handleSubmit();
    this.handleReset();
  }

  handleReset() {
    const $arrow = $('.js-back-arrow');

    $arrow.click((e) => {
      if ($('.js-hero-3').hasClass('active')) {
        $('.js-hero-3').removeClass('active');
        $('.js-hero-2').removeClass('deactive');
        $('.js-hero-1').removeClass('deactive').addClass('active');
      }

      $('.js-page-2').fadeOut(500, () => {
        $('.js-page-1').fadeIn(500);
      });

      $('li.flag').each(function () {
        $(this).removeClass('selected');
      });

      $('.column').each(function () {
        $(this).html('');
        $(this).removeClass('black');
        $(this).removeClass('white');
        $(this).removeClass('green');
        $(this).removeClass('blue');
        $(this).removeClass('red');
        $(this).removeClass('yellow');
      });

      $('.js-skewers-flag-1').removeClass(this.state.flag1.country);
      $('.js-skewers-flag-2').removeClass(this.state.flag2.country);

      this.state.flag1.country = null;
      this.state.flag1.color1 = null;
      this.state.flag1.color2 = null;
      this.state.flag1.color3 = null;
      this.state.flag1.color4 = null;

      this.state.flag2.country = null;
      this.state.flag2.color1 = null;
      this.state.flag2.color2 = null;
      this.state.flag2.color3 = null;
      this.state.flag2.color4 = null;

      $('button.js-btn-submit').attr('disabled', true);
      $('.js-skewers-flag-2').parent().show();
    });
  }

  handleScroll() {
    $(window).scroll(function () {
      if ($(window).scrollTop() + $(window).height() > $(document).height() / 2) {
        if (!$('.js-scroll-arrow').hasClass('rotated')) {
          $('.js-scroll-arrow').addClass('rotated');
        }

        if ($('.js-hero-1').hasClass('active')) {
          $('.js-hero-1').removeClass('active').addClass('deactive');
          $('.js-hero-2').addClass('active');
        }
      } else if ($(window).scrollTop() + $(window).height() < $(document).height() / 2) {
        if ($('.js-scroll-arrow').hasClass('rotated')) {
          $('.js-scroll-arrow').removeClass('rotated');
        }

        if ($('.js-hero-2').hasClass('active')) {
          $('.js-hero-2').removeClass('active');
          $('.js-hero-1').removeClass('deactive').addClass('active');
        }
      }
    });

    const $arrow = $('.js-scroll-arrow');

    $arrow.click((e) => {
      if ($(e.currentTarget).hasClass('rotated')) {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
      } else {
        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
      }
    });
  }

  handleFlagSelector() {
    const $flags = $('ul.flag-selector').children('li.flag');

    $flags.click((e) => {
      let $country = $(e.currentTarget).data('country');
      let $color1 = $(e.currentTarget).data('color1');
      let $color2 = $(e.currentTarget).data('color2');
      let $color3 = $(e.currentTarget).data('color3');
      let $color4 = $(e.currentTarget).data('color4');

      if (this.state.flag1.country === null) {
        $(e.currentTarget).addClass('selected');

        this.state.flag1.country = $country;
        this.state.flag1.color1 = $color1;
        this.state.flag1.color2 = $color2;
        this.state.flag1.color3 = $color3;
        this.state.flag1.color4 = $color4;

        $('button.js-btn-submit').attr('disabled', false);
      } else if (this.state.flag2.country === null) {
        $(e.currentTarget).addClass('selected');

        this.state.flag2.country = $country;
        this.state.flag2.color1 = $color1;
        this.state.flag2.color2 = $color2;
        this.state.flag2.color3 = $color3;
        this.state.flag2.color4 = $color4;

        //$('button.js-btn-submit').attr('disabled',false);
      }
    });
  }

  handleSubmit() {
    $('button.js-btn-submit').click((e) => {
      this.processSkewers();
    });
  }

  processSkewers() {
    if ($('.js-hero-1').hasClass('active')) {
      $('.js-hero-1').removeClass('active').addClass('deactive');
      $('.js-hero-3').addClass('active');
    } else if ($('.js-hero-2').hasClass('active')) {
      $('.js-hero-2').removeClass('active').addClass('deactive');
      $('.js-hero-3').addClass('active');
    }

    $('html, body').animate(
      {
        scrollTop: 0,
      },
      {
        duration: 1000,
        complete: () => {
          $('.js-page-1').fadeOut(500, () => {
            $('.js-page-2').fadeIn(500);
          });
        },
      }
    );

    $('.js-skewers-flag-1').addClass(this.state.flag1.country);

    $('.js-columns-1').children('.js-column-1').addClass(this.state.flag1.color1);
    $('.js-columns-1').children('.js-column-2').addClass(this.state.flag1.color2);
    $('.js-columns-1').children('.js-column-3').addClass(this.state.flag1.color3);
    $('.js-columns-1').children('.js-column-4').addClass(this.state.flag1.color4);

    if (this.state.flag2.country != null) {
      $('.js-skewers-flag-2').addClass(this.state.flag2.country);

      $('.js-columns-2').children('.js-column-1').addClass(this.state.flag2.color1);
      $('.js-columns-2').children('.js-column-2').addClass(this.state.flag2.color2);
      $('.js-columns-2').children('.js-column-3').addClass(this.state.flag2.color3);
      $('.js-columns-2').children('.js-column-4').addClass(this.state.flag2.color4);
    } else {
      $('.js-skewers-flag-2').parent().hide();
    }

    $('.column').each((index, element) => {
      if ($(element).hasClass('black') == true) {
        $(element).append(
          '<ul><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/black/' +
            this.menu.black.ingredient1.image +
            '"/></div><span>' +
            this.menu.black.ingredient1.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/black/' +
            this.menu.black.ingredient2.image +
            '"/></div><span>' +
            this.menu.black.ingredient2.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/black/' +
            this.menu.black.ingredient3.image +
            '"/></div><span>' +
            this.menu.black.ingredient3.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/black/' +
            this.menu.black.ingredient4.image +
            '"/></div><span>' +
            this.menu.black.ingredient4.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/black/' +
            this.menu.black.ingredient5.image +
            '"/></div><span>' +
            this.menu.black.ingredient5.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/black/' +
            this.menu.black.ingredient6.image +
            '"/></div><span>' +
            this.menu.black.ingredient6.name +
            '</span></li></ul>'
        );
      } else if ($(element).hasClass('blue') == true) {
        $(element).append(
          '<ul><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/blue/' +
            this.menu.blue.ingredient1.image +
            '"/></div><span>' +
            this.menu.blue.ingredient1.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/blue/' +
            this.menu.blue.ingredient2.image +
            '"/></div><span>' +
            this.menu.blue.ingredient2.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/blue/' +
            this.menu.blue.ingredient3.image +
            '"/></div><span>' +
            this.menu.blue.ingredient3.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/blue/' +
            this.menu.blue.ingredient4.image +
            '"/></div><span>' +
            this.menu.blue.ingredient4.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/blue/' +
            this.menu.blue.ingredient5.image +
            '"/></div><span>' +
            this.menu.blue.ingredient5.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/blue/' +
            this.menu.blue.ingredient6.image +
            '"/></div><span>' +
            this.menu.blue.ingredient6.name +
            '</span></li></ul>'
        );
      } else if ($(element).hasClass('green') == true) {
        $(element).append(
          '<ul><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/green/' +
            this.menu.green.ingredient1.image +
            '"/></div><span>' +
            this.menu.green.ingredient1.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/green/' +
            this.menu.green.ingredient2.image +
            '"/></div><span>' +
            this.menu.green.ingredient2.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/green/' +
            this.menu.green.ingredient3.image +
            '"/></div><span>' +
            this.menu.green.ingredient3.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/green/' +
            this.menu.green.ingredient4.image +
            '"/></div><span>' +
            this.menu.green.ingredient4.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/green/' +
            this.menu.green.ingredient5.image +
            '"/></div><span>' +
            this.menu.green.ingredient5.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/green/' +
            this.menu.green.ingredient6.image +
            '"/></div><span>' +
            this.menu.green.ingredient6.name +
            '</span></li></ul>'
        );
      } else if ($(element).hasClass('red') == true) {
        $(element).append(
          '<ul><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/red/' +
            this.menu.red.ingredient1.image +
            '"/></div><span>' +
            this.menu.red.ingredient1.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/red/' +
            this.menu.red.ingredient2.image +
            '"/></div><span>' +
            this.menu.red.ingredient2.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/red/' +
            this.menu.red.ingredient3.image +
            '"/></div><span>' +
            this.menu.red.ingredient3.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/red/' +
            this.menu.red.ingredient4.image +
            '"/></div><span>' +
            this.menu.red.ingredient4.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/red/' +
            this.menu.red.ingredient5.image +
            '"/></div><span>' +
            this.menu.red.ingredient5.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/red/' +
            this.menu.red.ingredient6.image +
            '"/></div><span>' +
            this.menu.red.ingredient6.name +
            '</span></li></ul>'
        );
      } else if ($(element).hasClass('white') == true) {
        $(element).append(
          '<ul><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/white/' +
            this.menu.white.ingredient1.image +
            '"/></div><span>' +
            this.menu.white.ingredient1.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/white/' +
            this.menu.white.ingredient2.image +
            '"/></div><span>' +
            this.menu.white.ingredient2.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/white/' +
            this.menu.white.ingredient3.image +
            '"/></div><span>' +
            this.menu.white.ingredient3.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/white/' +
            this.menu.white.ingredient4.image +
            '"/></div><span>' +
            this.menu.white.ingredient4.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/white/' +
            this.menu.white.ingredient5.image +
            '"/></div><span>' +
            this.menu.white.ingredient5.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/white/' +
            this.menu.white.ingredient6.image +
            '"/></div><span>' +
            this.menu.white.ingredient6.name +
            '</span></li></ul>'
        );
      } else if ($(element).hasClass('yellow') == true) {
        $(element).append(
          '<ul><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/yellow/' +
            this.menu.yellow.ingredient1.image +
            '"/></div><span>' +
            this.menu.yellow.ingredient1.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/yellow/' +
            this.menu.yellow.ingredient2.image +
            '"/></div><span>' +
            this.menu.yellow.ingredient2.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/yellow/' +
            this.menu.yellow.ingredient3.image +
            '"/></div><span>' +
            this.menu.yellow.ingredient3.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/yellow/' +
            this.menu.yellow.ingredient4.image +
            '"/></div><span>' +
            this.menu.yellow.ingredient4.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/yellow/' +
            this.menu.yellow.ingredient5.image +
            '"/></div><span>' +
            this.menu.yellow.ingredient5.name +
            '</span></li><li><div><img src="/wp-content/themes/electro/img/microsites/futbol/ingredients/yellow/' +
            this.menu.yellow.ingredient6.image +
            '"/></div><span>' +
            this.menu.yellow.ingredient6.name +
            '</span></li></ul>'
        );
      } else {
        //$(element).remove();
      }
    });
  }
}
